export function formatLotCount(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '-';
  const rounded = Math.round(n * 100) / 100;
  if (Math.abs(rounded - Math.round(rounded)) < 0.001) {
    return String(Math.round(rounded));
  }
  return rounded.toFixed(2);
}

function settingVariant(row) {
  const variant = String((row && row.lotVariant) || '').trim().toUpperCase();
  if (variant === 'MINI' || variant === 'MEGA') return variant;
  return '';
}

function scriptNames(stock) {
  const full = String((stock && (stock.dispname || stock.dispName || stock.scriptName)) || '').trim().toUpperCase();
  const script = String((stock && stock.scriptName) || '').trim().toUpperCase();
  const first = full.split(/\s+/)[0] || '';
  return new Set([full, script, first].filter(Boolean));
}

export function pickQuantityTemplateRow(rows, stock, lotVariant) {
  const segment = String((stock && stock.exchange) || '').trim().toUpperCase();
  const names = scriptNames(stock);
  const list = Array.isArray(rows) ? rows : Object.values(rows || {});
  const matches = list.filter((row) => {
    const rowSegment = String((row && row.segment) || '').trim().toUpperCase();
    const rowName = String((row && row.dispname) || '').trim().toUpperCase();
    return rowSegment === segment && names.has(rowName);
  });
  const wanted = String(lotVariant || 'MEGA').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';
  return matches.find((row) => settingVariant(row) === wanted)
    || matches.find((row) => settingVariant(row) === '')
    || (wanted === 'MINI' ? matches.find((row) => settingVariant(row) === 'MEGA') : null)
    || null;
}

function positionVariant(row) {
  return String((row && row.lotVariant) || 'MEGA').trim().toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';
}

function sameScript(row, stock) {
  const id = String((stock && (stock.instrumentIdentifier || stock.id)) || '');
  const otherId = String((row && (row.stockId || row.instrumentIdentifier)) || '');
  if (id && otherId && id === otherId) return true;
  const exchange = String((stock && stock.exchange) || '').trim().toUpperCase();
  const name = String((stock && (stock.dispname || stock.dispName || stock.stockName)) || '').trim().toUpperCase();
  const otherExchange = String((row && row.exchange) || '').trim().toUpperCase();
  const otherName = String((row && (row.stockName || row.dispname)) || '').trim().toUpperCase();
  return exchange !== '' && name !== '' && exchange === otherExchange && name === otherName;
}

export function openedLotsForScript(netPositions, stock, lotVariant, countAllVariants) {
  const wanted = String(lotVariant || 'MEGA').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';
  let lots = 0;
  let quantity = 0;
  (Array.isArray(netPositions) ? netPositions : []).forEach((position) => {
    if (!countAllVariants && positionVariant(position) !== wanted) return;
    if (!sameScript(position, stock)) return;
    const net = Number(position.netQty);
    const qty = Number.isFinite(net)
      ? Math.abs(net)
      : Math.abs(Number(position.buyQty || 0) - Number(position.sellQty || 0));
    const lotSize = Number(position.usedLotSize || position.lotSize || position.stockLotSize || (stock && stock.lotsize) || 1) || 1;
    if (qty > 0 && lotSize > 0) {
      quantity += qty;
      lots += qty / lotSize;
    }
  });
  return { quantity, lots };
}

export function countAllVariantsForRow(rows, stock, picked) {
  if (!picked || settingVariant(picked) === '') return true;
  const names = scriptNames(stock);
  const segment = String((stock && stock.exchange) || '').trim().toUpperCase();
  const list = Array.isArray(rows) ? rows : Object.values(rows || {});
  const matches = list.filter((row) => {
    const rowSegment = String((row && row.segment) || '').trim().toUpperCase();
    const rowName = String((row && row.dispname) || '').trim().toUpperCase();
    return rowSegment === segment && names.has(rowName);
  });
  const hasMini = matches.some((row) => settingVariant(row) === 'MINI');
  const hasMega = matches.some((row) => settingVariant(row) === 'MEGA');
  return !(hasMini && hasMega);
}
